import { Wheel } from "spin-wheel";

import { spinTurns } from "./wheel_spin.mjs";

// Replays a finished spin from the numbers the server stored for it -- the same sections
// snapshot, target, duration and rotation count the player watched, so the replay is the
// spin rather than an impression of it.
export default {
    mounted() {
        this.initWheel();
        this.play();

        this.handleEvent("wheel:replay", ({ game_id }) => {
            if (game_id !== this.el.dataset.gameId) return;

            this.play();
        });
    },

    updated() {
        if (!this.wheel) this.initWheel();
    },

    play() {
        if (!this.wheel || this.wheel.isSpinning) return;

        const { targetIndex, duration, rotations } = this.el.dataset;

        this.wheel.rotation = 0;
        this.wheel.spinToItem(Number(targetIndex), Number(duration), true, spinTurns(rotations), 1);
    },

    initWheel() {
        const canvas = this.el;

        if (!canvas) return;

        const sectionsData = JSON.parse(canvas.dataset.wheelSections || "[]");

        if (sectionsData.length === 0) return;

        const items = sectionsData.map((section) => ({
            label: `$${this.formatAmount(section.amount / 1000000)}`,
            backgroundColor: section.color,
            labelColor: this.getContrastColor(section.color),
        }));

        // Rebuilding without removing the previous wheel first leaks a canvas per patch.
        if (this.wheel) this.wheel.remove();

        this.wheel = new Wheel(canvas, {
            items: items,
            rotationResistance: -40,
            pointerAngle: 90,
            isInteractive: false,
            itemLabelFontSizeMax: 65,
            itemLabelAlign: "right",
            itemLabelRadius: 0.75,
        });
    },

    getContrastColor(hexColor) {
        const hex = hexColor.replace("#", "");
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 155 ? "#000000" : "#FFFFFF";
    },

    formatAmount(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    destroyed() {
        if (this.wheel) {
            this.wheel.remove();
        }
    },
};
